import { ElementNode, $createTextNode } from 'lexical';

export class FontFamilyNode extends ElementNode {
  __fontFamily;

  // eslint-disable-next-line default-param-last
  constructor(fontFamily = 'Arial', nodeKey) {
    // Provide default font family so constructor can be called without arguments
    super(nodeKey);
    this.__fontFamily = fontFamily;
  }

  static getType() {
    return 'fontFamily';
  }

  static clone(node) {
    return new FontFamilyNode(node.__fontFamily, node.__key);
  }

  static importJSON(serializedNode) {
    // eslint-disable-next-line no-use-before-define
    const node = $createFontFamilyNode('', serializedNode.fontFamily);
    // Lexical will handle importing children if they exist
    return node;
  }

  exportJSON() {
    const json = {
      type: 'fontFamily',
      version: 1,
      fontFamily: this.__fontFamily,
    };

    // Lexical will handle serializing children
    const children = this.getChildren();
    if (children.length > 0) {
      // Let Lexical handle the serialization
      // eslint-disable-next-line no-underscore-dangle
      json.children = children.map((child) => child.exportJSON());
    } else {
      json.children = [];
    }

    return json;
  }

  createDOM() {
    const span = document.createElement('span');
    span.style.fontFamily = this.__fontFamily;
    return span;
  }

  updateDOM(prevNode, dom) {
    if (prevNode.__fontFamily !== this.__fontFamily) {
      // eslint-disable-next-line no-param-reassign
      dom.style.fontFamily = this.__fontFamily;
    }
    return false;
  }

  getFontFamily() {
    return this.__fontFamily;
  }

  setFontFamily(fontFamily) {
    const writable = this.getWritable();
    writable.__fontFamily = fontFamily;
  }
}

// Factory function
export function $createFontFamilyNode(text = '', fontFamily = 'Arial') {
  const node = new FontFamilyNode(fontFamily);
  if (text) {
    node.append($createTextNode(text));
  }
  return node;
}

export function $isFontFamilyNode(node) {
  return node instanceof FontFamilyNode;
}
